module.exports = __webpack_public_path__ + "static/media/allergysymptoms-1_m@2x.be3e7902.jpg";